<template>
  <div class="card mr-3">
    <div class="card-body">
      <fieldset>
        <legend>
          {{title}}
          <label
            class="float-right checkAll form-check-label"
            v-bind:for="`checkAll${name}`"
          >
            <input
              type="checkbox"
              v-bind:id="`checkAll${name}`"
              @click="selectAll()"
              style="font-size: 0.6em"
              v-model="all"
            />Tout sélectionner
          </label>
        </legend>

        <div class="form-check-inline" v-for="el in data" v-bind:key="el[idprop]">
          <label class="form-check-label" v-bind:for="`${name}${el[idprop]}`">
            <input
              class="form-check-input"
              type="checkbox"
              :id="`${name}${el[idprop]}`"
              :name="`${name}${el[idprop]}`"
              v-model="selected"
              :value="el[idprop]"
              @change="update()"
            />
            {{el[nameprop]}}
          </label>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    data: {
      type: Array
    },
    idprop: {
      type: String
    },
    nameprop: {
      type: String
    },
    name: {
      type: String
    }
  },
  data() {
    return {
      selected: [],
      all: false
    };
  },
  methods: {
    selectAll() {
      this.all = !this.all;
      this.selected = [];
      if (this.all) {
        for (let el in this.data) {
          this.selected.push(this.data[el][this.idprop]);
        }
      }
    },
    update() {
      this.all = this.selected.length == this.data.length;
    }
  },
  watch: {
    selected: {
      handler: function() {
        let selection = [];
        for (let obj of this.selected) {
          if (obj) selection.push(obj);
        }
        this.$emit("newselection", { name: this.name, selected: selection });
        this.$emit('input', selection) // v-model
      }
    },
    data: {
      handler: function() {
        this.selectAll();
      }
    }
  }
};
</script>
